module.exports = __webpack_public_path__ + "static/media/step_two_bill.8f3c3e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/steps/step_two_bill.png
// module id = 1414
// module chunks = 0